import React from "react";
import { push } from "react-router-redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Search } from "app/modules/shared/components/index";
import {
  Pagination,
  SearchFilter
} from "app/modules/shared/components/Pagination/index";
import Table from "./Table";
import pagination from "../../pagination";

function RejectedCoreSearch({ pushHistory }) {
  return (
    <Search search={pagination} syncWithUrl>
      {searchProps => (
        <div>
          <div className="form-group form-group-searchbar has-feedback has-feedback-left">
            <i className="text-muted fa fa-search form-control-feedback form-control-feedback-left" />
            <div className="input-group">
              <SearchFilter
                {...searchProps}
                placeholder="Search by typing a company name, part # or serial #..."
                submitOnSingleResult={r =>
                  pushHistory(`/rejected-cores/${r.id}`)}
              />
            </div>
          </div>
          <h2>Rejected Cores</h2>
          <Table {...searchProps} />
          <Pagination {...searchProps} />
        </div>
      )}
    </Search>
  );
}

RejectedCoreSearch.propTypes = {
  pushHistory: PropTypes.func.isRequired
};

export default connect(undefined, { pushHistory: push })(RejectedCoreSearch);



// WEBPACK FOOTER //
// ./app/modules/RejectedCores/components/Search/RejectedCoreSearch.jsx